var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-4 mx-4"},[(_vm.form_not_offline)?_c('div',[_c('edit-not-local-but-remote',{attrs:{"options":_vm.options},on:{"goOnline":_vm.goOnline}})],1):_c('div',[_c('h5',[_vm._v(_vm._s(_vm.form_error_message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }